import styled from "styled-components";
import { Link } from "react-router-dom";

// Components
import { Button, Input } from "components/spocketUI/";

// Utils
import { media } from "utils/media";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
`;

export const Form = styled.form`
  width: 100%;
  max-width: 500px;
  display: flex;
  justify-content: center;

  ${media.PHONE`
    max-width: unset;
  `};
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${media.PHONE`
    max-width: unset;
  `};
`;

export const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin: 0px;
  width: auto;
  min-height: 34px;
  position: relative;
`;

export const StyledInput = styled(Input)`
  padding: 0 0px 12px 0;
  box-sizing: border-box;
  font-weight: 500;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid
    ${props =>
      props.hasError
        ? props.theme.colors.red.colorWarning
        : props.theme.colors.addOpacity({
            color: props.theme.colors.black.colorBlack300,
            opacity: 0.2
          })};
  height: 34px;
  margin-top: 5px;
  width: 100%;
  border-radius: 0;

  &::placeholder {
    color: ${props => props.theme.colors.black.colorBlack300};
    opacity: 1;
  }

  &:focus {
    outline: unset;
    border-color: unset;
    box-shadow: unset;
    border-bottom: 1px solid
      ${props =>
        props.hasError ? props.theme.colors.red.colorWarning : props.theme.colors.purple.colorPurple11};
  }
`;

const ErrorText = styled.p`
  position: absolute;
  margin-bottom: 0;
  font-family: Avenir;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 12px;
  color: ${props => props.theme.colors.red.colorWarning};
`;

export const EmailErrorText = styled(ErrorText)`
  bottom: -21px;
`;

export const PasswordErrorText = styled(ErrorText)`
  bottom: 20px;
`;

export const AuthErrorText = styled(ErrorText)`
  bottom: 21px;
`;

export const StyledButton = styled(Button)`
  font-family: Avenir;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 1px solid ${props => props.theme.colors.purple.colorPurple15};
  border-radius: 6px;
  font-weight: 500;
  line-height: normal;
  transition: background-color 0.3s ease-in-out 0s;
  height: 48px;
  width: 100%;
  background-color: ${props => props.theme.colors.white.colorWhite};
  color: ${props => props.theme.colors.purple.colorPurple15};
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.purple.colorPurple15};
    border-color: ${props => props.theme.colors.purple.colorPurple15};
    color: ${props => props.theme.colors.white.colorWhite};
  }
`;

export const StyledButtonMobile = styled(Button)`
  font-family: Avenir;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 1px solid ${props => props.theme.colors.purple.colorPurple15};
  border-radius: 6px;
  font-weight: 500;
  line-height: normal;
  transition: background-color 0.3s ease-in-out 0s;
  height: 48px;
  width: 100%;
  background-color: ${props => props.theme.colors.purple.colorPurple15};
  color: ${props => props.theme.colors.white.colorWhite};
  cursor: pointer;
`;

export const ShowPasswordButton = styled.button`
  position: absolute;
  right: 0px;
  border: unset;
  background-color: transparent;
  bottom: 48px;
  opacity: ${props => (props.showPasswordIsActive ? 0.5 : 1)};
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const ErrorIconContainer = styled.div`
  position: absolute;
  right: 0px;
  bottom: ${props => (props.type === "email" ? "0px" : "45px")};
`;

export const Icon = styled.img``;

export const ForgotPasswordContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 26px 0px 0px 0px;
  margin-bottom: -6px;
`;

export const ForgotPasswordLink = styled(Link)`
  color: ${props => props.theme.colors.purple.colorPurple15};
  text-align: center;
  font-family: Avenir;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border: unset;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;

  :hover {
    color: ${props => props.theme.colors.purple.colorPurple15};
  }
`;
